var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"com"}},[_c('navheader'),_vm._v(" "),_c('fixheader'),_vm._v(" "),_c('carousel'),_vm._v(" "),_c('about'),_vm._v(" "),_c('organizations'),_vm._v(" "),_c('news'),_vm._v(" "),_c('cooperation'),_vm._v(" "),_c('contact'),_vm._v(" "),_c('foot'),_vm._v(" "),_c('filing')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-713918c9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Com.vue
// module id = null
// module chunks = 